<template>
  <!-- Page Content -->
  <div class="content">
    <div class="navbar-div">
      <NavbarComponent :user="user" analysis="MULTI-ASSET" />
    </div>
    <div class="charts-div">
      <div class="col-xs-1 text-center" style="height: 200px">
        <router-link
          :to="{ name: 'summary' }"
          class="nav-link borderLeft"
          style="padding-right: 0"
          >Summary</router-link
        >
        <!--        <img src="../assets/images/globalMockUp.png" style="width:1000px" />-->
      </div>
    </div>
  </div>
</template>

<script>
import NavbarComponent from "../components/Navbar.vue";

export default {
  name: "global",
  components: {
    NavbarComponent
  },
  data() {
    return {
      user: [],
      companies: [],
      currencies: [],
      selectedCompany: 0,
      selectedPortfolios: 0,
      selectedCurrency: 0
    };
  },
  created() {
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    try {
      this.currencies = this.$store.state.currencies.all.items;
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    document.title = "Multi-Asset | QS";
  },
  methods: {
    onUserCompanySelection(value) {
      this.selectedCompany = value;
      this.selectedPortfolios = 0;
      this.selectedCurrency = 0;
      this.updateSpotMethod();
      this.getCandleData();
      this.getExpoData();
    } /*TODO: arreglar la logica cuando se selecciona uno, cuando esta vacio portfolio o currency, etc*/,
    onUserPortfolioSelection(value) {
      this.selectedPortfolios = value;
      this.selectedCurrency = 0;
      this.updateSpotMethod();
      this.getCandleData();
      this.getExpoData();
    },
    onUserCurrencySelection(value) {
      this.selectedCurrency = value;
      this.updateSpotMethod();
      this.getPortfolioData();
      this.getCandleData();
      this.getExpoData();
    }
  }
};
</script>
